<div class="d-flex justify-space-between">
  <div class="cursor align-items-center justify-content-start d-flex gap-10 mt-3 ml-3">
    <div
      matTooltip="Back"
      (click)="handleBack()"
    >
      <img alt="back" src="../../../../assets/images/arrow_circle_left.svg" />
    </div>
    <div class="prediction-header">Prediction</div>
  </div>
</div>
<div class="iframe-container">
  <iframe *ngIf="predictionsUrl" [src]="predictionsUrl" width="100%" height="800" style="border:none;"
    [style.display]="'block'">
  </iframe>
</div>